import { IDataTypeSerializer, IDataType, ISerializeContext, Property, EnumerationItem } from '@ecp-caf/common-structure';
import { DtoConstant } from '../../../define/gsp-dto-constant';
import { StructureTypeEnum } from '../../../define/structure-type-enum';
import { ExtendEnumType } from '../../../define/data-type/extend-enum-type';

export class ExtendEnumTypeSerializer implements IDataTypeSerializer{

    serialize(type:IDataType, ctxt: ISerializeContext): Object {
        let extendDtoType=type as ExtendEnumType;
        if(!extendDtoType){
            return null;
        }
        let jobj=new Object();
        jobj['kind']=DtoConstant.EXTEND_ENUM_TYPE;
        jobj['id']=extendDtoType.id;
        jobj['code']=extendDtoType.code;
        jobj['name']=extendDtoType.name;
        jobj['description']=extendDtoType.description;
        jobj['uri']=extendDtoType.uri;
        jobj['root']=extendDtoType.root;
        jobj['enable']=extendDtoType.enable;
        jobj['structureType']=extendDtoType.structureType;
        if(extendDtoType.properties){
            let jarry=jobj['properties']=new Array<Object>();
            extendDtoType.properties.forEach(prop => {
                let serializer=ctxt.getPropertySerializerFactory().get(prop.kind);
                jarry.push(serializer.serialize(prop,ctxt));
            });
        }
        if(extendDtoType.enumerationItems){
            let jarry=jobj['enumerationItems']=new Array<Object>();
            extendDtoType.enumerationItems.forEach(item => {
                jarry.push(item);
            });
        }
        return jobj;
    }    
    
    deserialize(jobj: Object, ctxt: ISerializeContext): IDataType {
        if(!jobj){
            return null;
        }
        let structureType=new ExtendEnumType();
        structureType.kind=jobj['kind'];
        structureType.id=jobj['id'];
        structureType.code=jobj['code'];
        structureType.name=jobj['name'];
        structureType.description=jobj['description'];
        structureType.root=jobj['root'] as boolean;
        structureType.enable=jobj['enable'] as boolean;
        structureType.uri=jobj['uri'];
        structureType.structureType=jobj['structureType'] as StructureTypeEnum;
        if(jobj['properties']){
            structureType.properties=new Array<Property>();
            jobj['properties'].forEach(structureTypeProp => {
                let serializer= ctxt.getPropertySerializerFactory().get(structureTypeProp.kind);
                structureType.properties.push(serializer.deserialize(structureTypeProp,ctxt));
            });
        }
        if(jobj['enumerationItems']){
            structureType.enumerationItems=new Array<EnumerationItem>();
            jobj['enumerationItems'].forEach(itemJobj => {
                structureType.enumerationItems.push(Object.assign(new EnumerationItem(),itemJobj));
            });
        }
        return structureType;
    }

}